import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'

import BootstrapVue from 'bootstrap-vue'
import Notifications from 'vue-notification'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(VueGtag, {
  config: { id: config.ANALYTICS_ID }
}, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
